import BaseMenuItem from '@material-ui/core/MenuItem'

const MenuItem = BaseMenuItem

export default MenuItem
